export default __webpack_public_path__ + "static/media/Greenline2025-DK.09f5d48c.svg";